import React, { useEffect, useMemo, useState } from "react";
import { DownloadFile } from "../../../../utils/downloadFile";

const Intelligence = ({ intelligencedata }) => {
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (intelligencedata) {
      setData(intelligencedata);
    }
  }, [intelligencedata]);

  const handleDownload = async (url, label) => {
    if (!url) return;
    try {
      await DownloadFile(
        url,
        (loading) => {
          setStatus(loading);
          setMessage(loading ? `Fetching ${label}...` : "");
        },
        `${label}.pdf`
      );
    } catch (err) {
      console.error(`Error downloading ${label}:`, err);
    }
  };

  const renderTurnover = useMemo(() => {
    if (!data?.turnover || data.turnover.length === 0)
      return (
        <div className="turnOver">
          <p>
            <span className="financial_tag">Turnover (in Crore)</span>
            <br />
            <b className="amount">N/A</b>
          </p>
        </div>
      );

    const latest = data.turnover[data.turnover.length - 1];
    const { financial_year, amount, currency, unit, balanceSheet } = latest;

    return (
      <div className="turnOver">
        <p>
          <b className="financial_year">
            {financial_year ? `FY: ${financial_year}` : ""}
          </b>
          <br />
          <span className="financial_tag">
            {unit ? "Turnover" : `Turnover ${currency ? "" : "(in Crore)"}`}
          </span>
          <br />
          <b className="amount">
            {!amount
              ? "N/A"
              : `${currency || "₹"} ${parseFloat(amount).toFixed(2)} ${
                  unit || ""
                }`}
          </b>
        </p>
        {balanceSheet && (
          <p>
            <button
              className="view-button"
              style={{ backgroundColor: "#393185" }}
              onClick={() => handleDownload(balanceSheet, "Balance_Sheet")}
            >
              <span className="view">View Balance Sheet</span>
            </button>
          </p>
        )}
      </div>
    );
  }, [data]);

  const renderNetProfit = useMemo(() => {
    if (!data?.net_profit || data.net_profit.length === 0)
      return (
        <div className="netProfit">
          <p>
            <span className="financial_tag">Net Profit (in Crore)</span>
            <br />
            <b className="amount">N/A</b>
          </p>
        </div>
      );

    const latest = data.net_profit[data.net_profit.length - 1];
    const { financial_year, amount, currency, unit, pnl_statement } = latest;

    return (
      <div className="netProfit">
        <p>
          <b className="financial_year">
            {financial_year ? `FY: ${financial_year}` : ""}
          </b>
          <br />
          <span className="financial_tag">
            {unit ? "Net Profit" : `Net Profit ${currency ? "" : "(in Crore)"}`}
          </span>
          <br />
          <b className="amount">
            {!amount
              ? "N/A"
              : `${currency || "₹"} ${parseFloat(amount).toFixed(2)} ${
                  unit || ""
                }`}
          </b>
        </p>
        {pnl_statement && (
          <p>
            <button
              className="view-button"
              style={{ backgroundColor: "#393185" }}
              onClick={() => handleDownload(pnl_statement, "PNL_Statement")}
            >
              <span className="view">View P&L Statement</span>
            </button>
          </p>
        )}
      </div>
    );
  }, [data]);

  const renderOwnedFleet = useMemo(() => {
    if (!data?.owned_fleet)
      return (
        <div className="ownedFleet">
          <p>
            <span className="financial_tag">Owned Fleet</span>
            <br />
            <b className="amount">N/A</b>
          </p>
        </div>
      );

    const { amount, fleet_list } = data.owned_fleet;
    return (
      <div className="ownedFleet">
        <p>
          <span className="financial_tag">Owned Fleet</span>
          <br />
          <b className="amount">
            {!amount ? "N/A" : parseFloat(amount).toFixed(2)}
          </b>
        </p>
        {fleet_list && (
          <p>
            <button
              className="view-button"
              style={{ backgroundColor: "#393185" }}
              onClick={() => handleDownload(fleet_list, "Fleet_List")}
            >
              <span className="view">View Fleet List</span>
            </button>
          </p>
        )}
      </div>
    );
  }, [data]);

  const renderAssociatedFleetStrength = useMemo(() => {
    const afs = data?.associated_fleet;
    return (
      <div className="fleetStrength">
        <p>
          <span className="financial_tag">Associated Fleet Strength</span>
          <br />
          <b className="amount">{afs?.amount || "N/A"}</b>
        </p>
      </div>
    );
  }, [data]);

  if (!data) {
    return (
      <div>
        <p>Details not available</p>
      </div>
    );
  }

  return (
    <div className="row">
      {renderTurnover}
      {renderNetProfit}
      {renderOwnedFleet}
      {renderAssociatedFleetStrength}
    </div>
  );
};

export default Intelligence;
